<template>
  <transition name="bg-popup-layer">
    <div
      v-if="visible"
      class="bg-popup-layer"
      role="dialog"
      aria-modal="true"
      :aria-label="$t('popup.aria')"
    >
      <div class="bg-popup-layer__backdrop" aria-hidden="true" />

      <div class="bg-popup-layer__inner">
        <div
          v-if="visibleItems.length"
          class="bg-popup-layer__row"
          :style="{ '--popup-count': visibleItems.length }"
        >
          <article
            v-for="(item, index) in visibleItems"
            :key="item.idx"
            class="bg-popup-card"
            :style="{ '--popup-index': index + 1 }"
          >
            <div
              class="bg-popup-card__content"
              :class="{
                'bg-popup-card__content--text': !item.isImage,
                'bg-popup-card__content--media': item.isImage
              }"
              v-html="item.contentHtml"
            />
            <div class="bg-popup-card__footer">
              <button
                type="button"
                class="bg-popup-card__btn"
                @click="hideFor24Hours(item.idx)"
              >
                {{ $t('popup.hide24h') }}
              </button>
              <button
                type="button"
                class="bg-popup-card__btn bg-popup-card__btn--close"
                @click="dismiss(item.idx)"
              >
                {{ $t('popup.close') }}
              </button>
            </div>
          </article>
        </div>

        <button
          type="button"
          class="bg-popup-layer__close-all"
          @click="closeAll"
        >
          {{ $t('popup.closeAll') }}
        </button>
      </div>
    </div>
  </transition>
</template>

<script>
import { SystemService } from '@/services'
import {
  filterVisiblePopups,
  hidePopupFor24Hours,
  isImagePopupContent,
  prepareNoticeContentHtml
} from '@/utils/popupNotice'

export default {
  name: 'BlackGoldPopupNoticeLayer',
  data () {
    return {
      visible: false,
      items: [],
      dismissedIds: []
    }
  },
  computed: {
    visibleItems () {
      return this.items.filter(item => !this.dismissedIds.includes(item.idx))
    }
  },
  watch: {
    visibleItems (list) {
      if (this.visible && list.length === 0) {
        this.closeAll()
      }
    },
    visible (open) {
      this.$emit('visibility-change', open)
    }
  },
  methods: {
    async loadAndShow () {
      try {
        const res = await SystemService.getQuickNoticeList()
        if (!res || !res.data || res.data.code !== 0 || !res.data.data) {
          return
        }
        const list = Array.isArray(res.data.data.list) ? res.data.data.list : []
        const popups = filterVisiblePopups(list).map(item => ({
          idx: item.idx,
          contentHtml: prepareNoticeContentHtml(item.text),
          isImage: isImagePopupContent(item.text)
        })).filter(item => item.contentHtml)

        if (!popups.length) return

        this.items = popups
        this.dismissedIds = []
        this.visible = true
      } catch (err) {
        // 팝업 실패 시 메인 화면은 그대로 유지
      }
    },
    dismiss (idx) {
      if (!this.dismissedIds.includes(idx)) {
        this.dismissedIds.push(idx)
      }
    },
    hideFor24Hours (idx) {
      hidePopupFor24Hours(idx)
      this.dismiss(idx)
    },
    closeAll () {
      this.visible = false
      this.items = []
      this.dismissedIds = []
    }
  }
}
</script>
